import { UserAdapter as CoreUserAdapter } from '@core/adapters';
import { HttpInterface } from '@core/http';
import { UserApiEndpoint } from '@api-endpoint';
import {
  FetchMobileVoucherInfoPayload,
  FetchMobileVoucherInfoResponse,
  FetchMobilePurchaseListResponse,
  FetchMobileVoucherUseListPayload,
  FetchMobileVoucherUseListResponse,
  RegistMobileVoucherPayload,
  WithdrawalGCardPayload,
  FetchGCardRegistListResponse,
  FetchGCardPointListResponse,
  FetchGCardPointSummaryResponse,
} from '@dto';
import {
  FetchMobileVoucherDetailResponse,
  FetchMobileVoucherListPayload,
  FetchMobileVoucherListResponse,
} from '@core/dto';

export class UserAdapter extends CoreUserAdapter {
  constructor(httpInstance: HttpInterface) {
    super(httpInstance);
  }

  async fetchMobileVoucherInfo(
    payload: FetchMobileVoucherInfoPayload
  ): Promise<FetchMobileVoucherInfoResponse> {
    const response = await this.http.get<FetchMobileVoucherInfoResponse>(
      UserApiEndpoint.fetchMobileVoucherInfo,
      payload
    );
    return response.data;
  }
  async registMobileVoucher(payload: RegistMobileVoucherPayload) {
    await this.http.post(UserApiEndpoint.registMobileVoucher, payload);
  }
  async fetchMobileVoucherPurchaseList(payload: {
    fromDate: string;
    toDate: string;
  }): Promise<FetchMobilePurchaseListResponse[]> {
    const response = await this.http.get<FetchMobilePurchaseListResponse[]>(
      UserApiEndpoint.fetchMobileVoucherPurchaseList,
      payload
    );
    return response.data;
  }
  async fetchMobileVoucherUseList(
    payload: FetchMobileVoucherUseListPayload
  ): Promise<FetchMobileVoucherUseListResponse> {
    const response = await this.http.get<FetchMobileVoucherUseListResponse>(
      UserApiEndpoint.fetchMobileVoucherUseList,
      payload
    );
    return response.data;
  }

  async fetchMobileVoucherList(
    payload: FetchMobileVoucherListPayload
  ): Promise<FetchMobileVoucherListResponse> {
    const response = await this.http.get<FetchMobileVoucherListResponse>(
      UserApiEndpoint.fetchMobileVoucherList,
      payload
    );
    return response.data;
  }

  async fetchMobileVoucherDetail(
    depositId: number
  ): Promise<FetchMobileVoucherDetailResponse[]> {
    const url = this.http.replacedUrl(
      UserApiEndpoint.fetchMobileVoucherDetail,
      { depositId }
    );
    const response =
      await this.http.get<FetchMobileVoucherDetailResponse[]>(url);
    return response.data;
  }

  async fetchGCardRegistList(): Promise<FetchGCardRegistListResponse> {
    const response = await this.http.get<FetchGCardRegistListResponse>(
      UserApiEndpoint.fetchGCardRegistList
    );
    return response.data;
  }
  async fetchGCardPointList(
    payload: FetchMobileVoucherUseListPayload
  ): Promise<FetchGCardPointListResponse> {
    const response = await this.http.get<FetchGCardPointListResponse>(
      UserApiEndpoint.fetchGCardPointList,
      payload
    );
    return response.data;
  }
  async fetchGCardPointSummary(): Promise<FetchGCardPointSummaryResponse> {
    const response = await this.http.get<FetchGCardPointSummaryResponse>(
      UserApiEndpoint.fetchGCardPointSummary
    );
    return response.data;
  }
  async withdrawalGCard(payload: WithdrawalGCardPayload): Promise<void> {
    await this.http.post<void>(UserApiEndpoint.withdrawalGCard, payload);
  }
}
